"use client";
import React from "react";
import * as _Builtin from "./_Builtin";
import * as _interactions from "./interactions";
import * as _utils from "./utils";
import _styles from "./SponsoredListingStats.module.css";

const _interactionsData = JSON.parse(
  '{"events":{"e-51":{"id":"e-51","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInBottom","autoStopEventId":"e-52"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"fe2ee0c3-6c22-5a3c-83fb-b6a7ba2b3d48","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"fe2ee0c3-6c22-5a3c-83fb-b6a7ba2b3d48","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":100,"direction":"BOTTOM","effectIn":true},"createdOn":1691771338717},"e-171":{"id":"e-171","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SHRINK_EFFECT","instant":false,"config":{"actionListId":"shrinkIn","autoStopEventId":"e-172"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"fe2ee0c3-6c22-5a3c-83fb-b6a7ba2b3d62","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"fe2ee0c3-6c22-5a3c-83fb-b6a7ba2b3d62","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":200,"direction":null,"effectIn":true},"createdOn":1692830812036},"e-173":{"id":"e-173","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SHRINK_EFFECT","instant":false,"config":{"actionListId":"shrinkIn","autoStopEventId":"e-174"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"fe2ee0c3-6c22-5a3c-83fb-b6a7ba2b3d6f","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"fe2ee0c3-6c22-5a3c-83fb-b6a7ba2b3d6f","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":400,"direction":null,"effectIn":true},"createdOn":1692830812036},"e-175":{"id":"e-175","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SHRINK_EFFECT","instant":false,"config":{"actionListId":"shrinkIn","autoStopEventId":"e-176"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"fe2ee0c3-6c22-5a3c-83fb-b6a7ba2b3d7c","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"fe2ee0c3-6c22-5a3c-83fb-b6a7ba2b3d7c","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":600,"direction":null,"effectIn":true},"createdOn":1692830812036},"e-177":{"id":"e-177","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInBottom","autoStopEventId":"e-178"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"fe2ee0c3-6c22-5a3c-83fb-b6a7ba2b3d4a","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"fe2ee0c3-6c22-5a3c-83fb-b6a7ba2b3d4a","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":0,"direction":"BOTTOM","effectIn":true},"createdOn":1692832238581}},"actionLists":{"slideInBottom":{"id":"slideInBottom","useFirstGroupAsInitialState":true,"actionItemGroups":[{"actionItems":[{"actionTypeId":"STYLE_OPACITY","config":{"delay":0,"duration":0,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"value":0}}]},{"actionItems":[{"actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"duration":0,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"xValue":0,"yValue":100,"xUnit":"PX","yUnit":"PX","zUnit":"PX"}}]},{"actionItems":[{"actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"outQuart","duration":1000,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"xValue":0,"yValue":0,"xUnit":"PX","yUnit":"PX","zUnit":"PX"}},{"actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"outQuart","duration":1000,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"value":1}}]}]},"shrinkIn":{"id":"shrinkIn","useFirstGroupAsInitialState":true,"actionItemGroups":[{"actionItems":[{"actionTypeId":"STYLE_OPACITY","config":{"delay":0,"duration":0,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"value":0}}]},{"actionItems":[{"actionTypeId":"TRANSFORM_SCALE","config":{"delay":0,"duration":0,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"xValue":1.25,"yValue":1.25}}]},{"actionItems":[{"actionTypeId":"TRANSFORM_SCALE","config":{"delay":0,"easing":"outQuart","duration":1000,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"xValue":1,"yValue":1}},{"actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"outQuart","duration":1000,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"value":1}}]}]}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}'
);

export function SponsoredListingStats({
  as: _Component = _Builtin.Section,
  counterRuntimeProps = {},
  counter = {},
  viewCountText = "300%",
  inquiresCountText = "%",
  leadsCountText = "%",
}) {
  _interactions.useInteractions(_interactionsData, _styles);

  return (
    <_Component
      className={_utils.cx(_styles, "sponsored-listings-stats")}
      grid={{
        type: "section",
      }}
      tag="section"
      id="SponsoredListingStats"
    >
      <_Builtin.Container
        className={_utils.cx(_styles, "pricing-page-solutions-container")}
        tag="div"
      >
        <_Builtin.Block
          className={_utils.cx(_styles, "pricing-page-solutions-main-block")}
          tag="div"
        >
          <_Builtin.Heading
            className={_utils.cx(_styles, "sponsored-listings-stats-heading")}
            data-w-id="fe2ee0c3-6c22-5a3c-83fb-b6a7ba2b3d48"
            tag="h2"
          >
            {"More leads, less vacancies"}
          </_Builtin.Heading>
          <_Builtin.Block
            className={_utils.cx(_styles, "flex-row", "light")}
            data-w-id="fe2ee0c3-6c22-5a3c-83fb-b6a7ba2b3d4a"
            tag="div"
          >
            <_Builtin.Block
              className={_utils.cx(
                _styles,
                "inline-block-3",
                "inline-text-pre-tooltip"
              )}
              tag="div"
            >
              {"Expand your audience while reaching "}
            </_Builtin.Block>
            <_Builtin.DropdownWrapper
              className={_utils.cx(_styles, "tooltip-dropdown", "inline")}
              tag="div"
              delay={0}
              hover={true}
            >
              <_Builtin.DropdownToggle
                className={_utils.cx(_styles, "tooltip-content")}
                tag="div"
              >
                <_Builtin.Link
                  className={_utils.cx(_styles, "link-2")}
                  button={false}
                  id="sl-anchor-verified"
                  block=""
                  options={{
                    href: "https://liv.rent/blog/livrent/rental-verification-process",
                  }}
                >
                  {"verified"}
                </_Builtin.Link>
              </_Builtin.DropdownToggle>
              <_Builtin.DropdownList
                className={_utils.cx(_styles, "tooltip-anchor", "top")}
                tag="nav"
              >
                <_Builtin.Block
                  className={_utils.cx(_styles, "tooltip-wrappersdsd")}
                  tag="div"
                  data-cy="step5"
                >
                  <_Builtin.Block
                    className={_utils.cx(_styles, "tooltip-container", "_10")}
                    tag="div"
                  >
                    <_Builtin.Block
                      className={_utils.cx(
                        _styles,
                        "inline-block-3",
                        "inside-tooltp"
                      )}
                      tag="div"
                    >
                      {"Renters who have a verified badge"}
                      <br />
                    </_Builtin.Block>
                    <_Builtin.Image
                      className={_utils.cx(
                        _styles,
                        "inline-block-3",
                        "verified-badge"
                      )}
                      loading="lazy"
                      width="20"
                      height="20"
                      alt=""
                      src="https://uploads-ssl.webflow.com/64d3f7fe1cc4f17b36a7a5ef/64e63e6663f9ecf823e8538d_id-verified-badge.svg"
                    />
                    <_Builtin.Block
                      className={_utils.cx(
                        _styles,
                        "inline-block-3",
                        "inside-tooltp"
                      )}
                      tag="div"
                    >
                      {
                        "next to their name have completed verification by submitting a government-issued ID and a selfie that matches their profile information. "
                      }
                      <_Builtin.Link
                        button={false}
                        id="sl-anchor-verified-learnmore"
                        block=""
                        options={{
                          href: "https://liv.rent/blog/livrent/rental-verification-process/",
                          target: "_blank",
                        }}
                      >
                        {"Learn more"}
                      </_Builtin.Link>
                      <br />
                    </_Builtin.Block>
                  </_Builtin.Block>
                  <_Builtin.Block
                    className={_utils.cx(_styles, "tooltip-diamond", "bottom")}
                    tag="div"
                  />
                </_Builtin.Block>
              </_Builtin.DropdownList>
            </_Builtin.DropdownWrapper>
            <_Builtin.Block
              className={_utils.cx(_styles, "inline-block-3")}
              tag="div"
            >
              {", trustworthy tenants."}
            </_Builtin.Block>
          </_Builtin.Block>
        </_Builtin.Block>
      </_Builtin.Container>
      <_Builtin.Container
        className={_utils.cx(_styles, "counter-container")}
        tag="div"
      >
        <_Builtin.Block
          className={_utils.cx(_styles, "counter-main-block")}
          tag="div"
        >
          <_Builtin.Block
            className={_utils.cx(_styles, "count-main-block-2")}
            id={_utils.cx(
              _styles,
              "w-node-fe2ee0c3-6c22-5a3c-83fb-b6a7ba2b3d62-ba2b3d44"
            )}
            data-w-id="fe2ee0c3-6c22-5a3c-83fb-b6a7ba2b3d62"
            tag="div"
          >
            <_Builtin.Block
              className={_utils.cx(_styles, "count-icon-block")}
              tag="div"
            >
              <_Builtin.Image
                className={_utils.cx(_styles, "image")}
                loading="lazy"
                width="auto"
                height="auto"
                alt=""
                src="https://uploads-ssl.webflow.com/64d3f7fe1cc4f17b36a7a5ef/64e7bf5aacd30224a6438216_views%203.svg"
              />
            </_Builtin.Block>
            <_Builtin.BlockContainer
              className={_utils.cx(_styles, "stats-container-copy")}
              grid={{
                type: "container",
              }}
              tag="div"
            >
              <_Builtin.Block
                className={_utils.cx(
                  _styles,
                  "stats-heading-text",
                  "no-margin"
                )}
                tag="div"
              >
                {viewCountText}
              </_Builtin.Block>
              <_Builtin.Block
                className={_utils.cx(_styles, "sponsored-listings-stats-small")}
                tag="div"
              >
                <_Builtin.Strong>{"more views"}</_Builtin.Strong>
              </_Builtin.Block>
            </_Builtin.BlockContainer>
            <_Builtin.Paragraph
              className={_utils.cx(_styles, "stats-description")}
            >
              {"Get more eyes on your listing with attention-grabbing ads."}
            </_Builtin.Paragraph>
          </_Builtin.Block>
          <_Builtin.Block
            className={_utils.cx(_styles, "count-main-block-2")}
            id={_utils.cx(
              _styles,
              "w-node-fe2ee0c3-6c22-5a3c-83fb-b6a7ba2b3d6f-ba2b3d44"
            )}
            data-w-id="fe2ee0c3-6c22-5a3c-83fb-b6a7ba2b3d6f"
            tag="div"
          >
            <_Builtin.Block
              className={_utils.cx(_styles, "count-icon-block")}
              tag="div"
            >
              <_Builtin.Image
                className={_utils.cx(_styles, "image-2")}
                loading="lazy"
                width="auto"
                height="auto"
                alt=""
                src="https://uploads-ssl.webflow.com/64d3f7fe1cc4f17b36a7a5ef/64e7bf67ffcdaa595892fb94_inquiries%203.svg"
              />
            </_Builtin.Block>
            <_Builtin.BlockContainer
              className={_utils.cx(_styles, "stats-container-copy")}
              grid={{
                type: "container",
              }}
              tag="div"
            >
              <_Builtin.Block
                className={_utils.cx(
                  _styles,
                  "stats-heading-text",
                  "no-margin"
                )}
                tag="div"
              >
                {inquiresCountText}
              </_Builtin.Block>
              <_Builtin.Block
                className={_utils.cx(_styles, "sponsored-listings-stats-small")}
                tag="div"
              >
                <_Builtin.Strong className={_utils.cx(_styles, "bold-text-3")}>
                  {"more inquiries"}
                </_Builtin.Strong>
              </_Builtin.Block>
            </_Builtin.BlockContainer>
            <_Builtin.Paragraph
              className={_utils.cx(_styles, "stats-description")}
            >
              {"Reach interested renters with relevant search queries."}
            </_Builtin.Paragraph>
          </_Builtin.Block>
          <_Builtin.Block
            className={_utils.cx(_styles, "count-main-block-2")}
            id={_utils.cx(
              _styles,
              "w-node-fe2ee0c3-6c22-5a3c-83fb-b6a7ba2b3d7c-ba2b3d44"
            )}
            data-w-id="fe2ee0c3-6c22-5a3c-83fb-b6a7ba2b3d7c"
            tag="div"
          >
            <_Builtin.Block
              className={_utils.cx(_styles, "count-icon-block")}
              tag="div"
            >
              <_Builtin.Image
                className={_utils.cx(_styles, "image-3")}
                loading="lazy"
                width="auto"
                height="auto"
                alt=""
                src="https://uploads-ssl.webflow.com/64d3f7fe1cc4f17b36a7a5ef/64e7bf71c7788d0652fba901_leads%203.svg"
              />
            </_Builtin.Block>
            <_Builtin.BlockContainer
              className={_utils.cx(_styles, "stats-container-copy")}
              grid={{
                type: "container",
              }}
              tag="div"
            >
              <_Builtin.Block
                className={_utils.cx(
                  _styles,
                  "stats-heading-text",
                  "no-margin"
                )}
                tag="div"
              >
                {leadsCountText}
              </_Builtin.Block>
              <_Builtin.Block
                className={_utils.cx(_styles, "sponsored-listings-stats-small")}
                tag="div"
              >
                <_Builtin.Strong>{"more qualified leads"}</_Builtin.Strong>
              </_Builtin.Block>
            </_Builtin.BlockContainer>
            <_Builtin.Paragraph
              className={_utils.cx(_styles, "stats-description")}
            >
              {"We verify applicants' identity, income, and employment."}
            </_Builtin.Paragraph>
          </_Builtin.Block>
        </_Builtin.Block>
      </_Builtin.Container>
    </_Component>
  );
}
